import React from 'react';

/**
 * Mobile Player Drones Component
 * Positioned at bottom-right, left of the end turn button
 */
export const MobilePlayerDrones = ({
  you,
  gameState,
  yourTurn,
  deployTargetMode,
  selectedDeployOrderId,
  handleTargetDeploy,
  replaceDroneTargetMode,
  selectedReplaceDroneInstanceId,
  setClickedDroneForReplace,
  clickedDroneForReplace,
  selectedOrderInstanceId,
  setReplaceDroneTargetMode,
  setSelectedReplaceDroneId,
  selectedOrderId,
  setSelectedReplaceDroneInstanceId,
  activateDrone,
  handleReplaceDrone,
  handleCancelReplaceDrone
}) => {
  return (
    <div
      className="player-drone-zone-mobile"
      style={{
        position: "absolute",
        bottom: "5px",
        right: "75px",
        zIndex: 1002,
        display: "flex",
        gap: "2px",
        flexDirection: "row",
        transform: "scale(0.35)",
        transformOrigin: "bottom right"
      }}
    >
      {you.drones?.filter(drone => !drone.markedForRemoval).map((drone, index) => {
        const allPlayerIds = gameState?.players || (gameState?.state ? Object.keys(gameState.state) : []);
        let disruptorDeployed = false;
        for (const pid of allPlayerIds) {
          const p = gameState?.state?.[pid];
          if (p && p.playedOrders) {
            for (const zone of ['front', 'flank']) {
              if (p.playedOrders[zone]) {
                for (const unit of p.playedOrders[zone]) {
                  if (unit && unit.id === 502 && unit.health > 0) {
                    disruptorDeployed = true;
                    break;
                  }
                }
                if (disruptorDeployed) break;
              }
            }
            if (disruptorDeployed) break;
          }
        }
        
        const canActivate = yourTurn && (drone.charges > 0 || drone.charges === undefined) && !drone.usedThisTurn && !disruptorDeployed;
        
        return (
          <div
            key={`player-drone-mobile-${index}`}
            style={{
              width: '80px',
              height: '60px',
              backgroundColor: '#333',
              border: canActivate ? '2px solid #2c5aa0' : '2px solid #444',
              borderRadius: '4px',
              cursor: canActivate ? 'pointer' : 'default',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: canActivate ? 1 : 0.6,
              overflow: 'visible'
            }}
            data-tooltip={`${drone.name} - ${drone.description || 'Drone'}${drone.charges !== undefined ? ` (${drone.charges} charges)` : ' (permanent effect)'}${drone.usedThisTurn ? ' - Used this turn' : ''}${disruptorDeployed ? ' - Inactive (Disruptor deployed)' : ''}`}
            onClick={() => {
              if (deployTargetMode && selectedDeployOrderId) {
                handleTargetDeploy('drone', index, 'friendly');
                return;
              }
              
              if (replaceDroneTargetMode && selectedReplaceDroneInstanceId) {
                setClickedDroneForReplace({
                  ...drone,
                  index
                });
                return;
              }
              
              if (selectedOrderInstanceId && !replaceDroneTargetMode) {
                const selectedOrder = you?.hand?.find(o => o.instanceId === selectedOrderInstanceId);
                if (selectedOrder?.type === 'Drone') {
                  const dronesCount = you.drones?.filter(d => !d.markedForRemoval).length || 0;
                  if (dronesCount >= 4) {
                    setReplaceDroneTargetMode(true);
                    setSelectedReplaceDroneId(selectedOrderId);
                    setSelectedReplaceDroneInstanceId(selectedOrderInstanceId);
                    setClickedDroneForReplace({
                      ...drone,
                      index
                    });
                    return;
                  }
                }
              }
              
              if (canActivate) {
                activateDrone(drone.instanceId);
              }
            }}
          >
            <img
              src={`/images/${drone.id}.jpg`}
              alt={drone.name}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 1
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            {drone.charges !== undefined && drone.charges > 0 && (
              <div style={{
                color: 'white',
                fontSize: '16px',
                fontWeight: 'bold',
                textShadow: '1px 1px 1px rgba(0,0,0,0.8)',
                position: 'absolute',
                top: '2px',
                right: '2px',
                backgroundColor: 'rgba(0,0,0,0.7)',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2
              }}>
                {drone.charges}
              </div>
            )}
            
            {replaceDroneTargetMode && clickedDroneForReplace && clickedDroneForReplace.instanceId === drone.instanceId && (
              <div style={{
                position: 'absolute',
                bottom: '3px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: '6px',
                zIndex: 3
              }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleReplaceDrone(clickedDroneForReplace);
                  }}
                  style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    border: 'none',
                    backgroundColor: '#4caf50',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
                    padding: 0
                  }}
                  data-tooltip="Replace drone"
                >
                  ✓
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCancelReplaceDrone();
                  }}
                  style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    border: 'none',
                    backgroundColor: '#f44336',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
                    padding: 0
                  }}
                  data-tooltip="Cancel replacement"
                >
                  ✗
                </button>
              </div>
            )}
          </div>
        );
      })}
      {/* Empty drone slots */}
      {Array.from({ length: 4 - (you.drones?.filter(drone => !drone.markedForRemoval).length || 0) }).map((_, index) => (
        <div
          key={`empty-player-drone-mobile-${index}`}
          style={{
            width: '80px',
            height: '60px',
            backgroundColor: '#333',
            border: '2px solid #555',
            borderRadius: '4px',
            opacity: 0.3
          }}
        />
      ))}
    </div>
  );
};

export default MobilePlayerDrones;

